import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const LeaveChatSession = gql`
  mutation LeaveChat(
    $idempotencyId: IdempotencyToken!
    $input: LeaveChatInput!
  ) {
    leaveChat(idempotencyId: $idempotencyId, input: $input) {
      __typename
      ... on LeaveChatError {
        ...error
      }
      ... on LeaveChatSuccess {
        id
      }
    }
  }
  ${error}
`;

export default LeaveChatSession;
